<div class="main-container rr-container-color container-fluid">
  <div class="row" style="padding-bottom: 100px; overflow: hidden">
    <div class="col-12">
      <div class="row d-flex flex-wrap flex-column flex-lg-row justify-content-between align-items-center px-4">
        <div *ngIf="isLoadingDataSheets || isLoadingField" class="col-12 mb-2">
          <app-loading-indicator [medium]="true" [message]="'Loading field data'"></app-loading-indicator>
        </div>
        <div *ngIf="!isLoadingDataSheets" class="col-12">
          <div *ngIf="alertMessage" class="alert alert-warning" role="alert">
            {{ alertMessage }} <a href="mailto:support@mi4.com">support&#64;mi4.com</a> to create a data sheet.
          </div>
          <div *ngIf="errorGetDataSheets" class="pt-4 text-center text-danger">
            <strong>{{ errorMessage }}</strong>
          </div>
          <div class="justify-content-center col-6">
            <p>To view run tickets, please select a date.</p>
            <p-calendar class="max-w-full"
                        [(ngModel)]="startDate"
                        [inline]="true"
                        [showWeek]="true"
                        [maxDate]="today"
                        (onSelect)="onDateSelect($event)" />
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
